import { render, staticRenderFns } from "./FooterListIcon.vue?vue&type=template&id=1c4c5d74&"
import script from "./FooterListIcon.vue?vue&type=script&lang=js&"
export * from "./FooterListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports